<template>
    <div class="accordion-body collapse" :id="'epd_'+account.PersonAccountId">
        <div class="accordion-body__inner edm-connect block">
            <div class="edm-connect__close">
                <a :href="'#epd_'+account.PersonAccountId" class="button-icon button-icon--th-main" data-toggle="collapse"><i class="icon icon--close"></i></a>
            </div>
            <div class="edm-connect__left">
                <div class="edm-connect__title text-bold">
                    <!--Переход на электронный платёжный документ (ЕПД)-->
                    Электронный платёжный документ (ЕПД)
                </div>
                <div class="edm-connect__descr">
                    В данном разделе Вы можете скачать Единый Платежный Документ (ЕПД), такой же как приходит к Вам в почтовый ящик.<br /><br />
                    Для этого выберите месяц, за который необходим платежный документ, и нажмите кнопку «Сформировать».
                </div>
                <div class="edm-connect__doc-wrapper">
                    <!--<div class="edm-connect__doc-text">
                        * Если ЛС добавлен в ЕПП нeскольких пользователей, изменения будут синхронизированы и отобразятся у всех пользователей
                    </div>-->
                    <div class="edm-connect__doc">
                        <form class="order-filter js-form">
                            <label class="txt-input edm-connect__doc-input">
                                <div class="txt-input__label text-bold">
                                    Выберите период
                                </div>
                                <div class="txt-input__input">
                                    <input v-bind:id="'date-picker-'+account.PersonAccountId" ref="input" type='text' class="txt-input__field input epp-date-picker" readonly />
                                    <div class="txt-input__icon fab-icon">
                                        <i class="icon icon--calendar"></i>
                                    </div>
                                </div>
                            </label>
                            <div class="edm-connect__doc-submit">
                                <div class="report__ctrl panel">
                                    <div class="epd__loader epd-button button button--th-main js-form-payment js-hide" v-on:click="setperiod(account)"
                                         v-bind:class="{'is-disable':!readyPdf}">
                                        <span v-if="readyPdf" class="button__text">Сформировать</span>
                                        <span v-else class="button__text">Формируется</span>
                                        <!--<span class="button__text--overlay">Формируется</span>-->
                                    </div>
                                    <a href="" class="epd__loader-remove button-icon button-icon--th-help"><i class="icon icon--remove"></i></a>
                                </div>
                                <!--<div class="order-panel__ctrl">
                                    <a href="#" class="epd-button button button--th-main js-doc-download" style="display: none;">
                                        <span class="button__text">Скачать</span>
                                    </a>
                                </div>-->
                            </div>
                        </form> <br />
                        <p v-if="errorEPD" style="color:red">Формирование ЕПД за выбранный период невозможно. Обратитесь в организацию, которая являлась исполнителем коммунальных услуг в данном периоде</p>
                    </div>
                </div>
            </div>

            <!--<div class="edm-connect__right object__ctrl-down">
                <div class="edm-connect__item">
                    <div class="edm-connect__row">
                        <h5 class="edm-connect__subtitle">
                            Настроить способ ежемесячного получения ЕПД по ЛС:
                        </h5>-->
            <!--<div class="edm-connect__number">-->
            <!--{{account.AccountNumber}}-->
            <!--</div>-->
            <!--</div>
            <div class="edm-connect__name">-->
            <!--<span class="object__value-name">Адрес: </span>{{account.City}}, {{account.Address}}-->
            <!--<span class="object__value-name">Адрес: </span>-->
            <!--</div>
            </div>
            <div class="edm-connect__steps js-checkox-container">
                <div class="edm-connect__item">
                    <h5 class="edm-connect__row edm-connect__subtitle">
                        Шаг 1. Адрес электронной почты для доставки ЕПД
                    </h5>
                    <div class="edm-connect__input">
                        <label class="txt-input">
                            <div class="txt-input__input">-->
            <!--<input class="txt-input__field txt-input__field--number input" type="text" value="" disabled>-->
            <!--<div class="txt-input__required txt-input__required--error"></div>
                    </div>
                </label>
            </div>
            <p class="edm-connect__small-text">Рассылка возможна только на электронный адрес из профиля</p>
            <p class="edm-connect__small-text">Если указанный электронный адрес неактуален,</p>-->
            <!--<p class="edm-connect__small-text">необходимо перейти в <a href="<?=SITE_TEMPLATE_PATH?>/profiles/settings/" class="link link--underline"><span class="link__text">настройки профиля</span></a> и изменить его.</p>-->
            <!--<p class="edm-connect__small-text">необходимо перейти в настройки профиля и изменить его.</p>
            </div>
            <div class="edm-connect__item">
                <h5 class="edm-connect__row edm-connect__subtitle">
                    Шаг 2. Выбор ежемесячного способа получения ЕПД
                </h5>
                <label class="radio-row edm-connect__radio">
                    <input type="radio" name="contractor_3" class="radio-row__radio js-change-button-checkbox" data-type-get-way="Бумажный" data-checkbox-toggle checked disabled="disabled">
                    <div class="radio-row__check edm-connect__radio-check"></div>
                    <div class="radio-row__body">
                        На бумажном носителе
                    </div>
                </label>
                <label class="radio-row edm-connect__radio">
                    <input type="radio" name="contractor_3" class="radio-row__radio js-change-button-checkbox" data-type-get-way="Почта+Email" data-checkbox-toggle disabled="disabled">
                    <div class="radio-row__check edm-connect__radio-check"></div>
                    <div class="radio-row__body">
                        По электронной почте (e-mail) и на бумажном носителе
                    </div>
                </label>
                <div class="edm-connect__radio-row edm-connect__radio-row--wrap">
                    <label class="radio-row edm-connect__radio">
                        <input type="radio" name="contractor_3" class="radio-row__radio js-change-button-checkbox js-blue-text" data-type-get-way="Электронный" :data-checkbox-toggle="'#edm-other_'+account.PersonAccountId" data-checkbox-toggle-main disabled="disabled">
                        <div class="radio-row__check edm-connect__radio-check"></div>
                        <div class="radio-row__body">
                            Только по электронной почте
                        </div>
                    </label>
                    <div class="accordion-body collapse" :id="'#edm-other_'+account.PersonAccountId">
                        <div class="accordion-body__inner edm-connect__other-text">
                            Выбирая данный вариант, Вы отказываетесь от доставки ЕПД в бумажном виде. Документ будет поступать в электронном виде на эл.адрес*
                        </div>
                    </div>
                </div>
            </div>
            <div class="edm-connect__item">
                <h5 class="edm-connect__row edm-connect__subtitle">
                    Шаг 3. Выбор способа подтверждения и ввод проверочного кода
                </h5>
                <label class="radio-row edm-connect__radio js-edm-confirmation">
                    <input type="radio" name="confirmation_3" class="radio-row__radio" disabled="disabled">
                    <div class="radio-row__check edm-connect__radio-check"></div>
                    <div class="radio-row__body">
                        По Вашему номеру телефона-->
            <!--По Вашему номеру телефона (+7 (923) 305-1983)-->
            <!--</div>
            </label>
            <label class="radio-row edm-connect__radio js-edm-confirmation">
                <input type="radio" name="confirmation_3" class="radio-row__radio" disabled="disabled">
                <div class="radio-row__check edm-connect__radio-check"></div>
                <div class="radio-row__body">
                    Письмом на указанный e-mail-->
            <!--Письмом на указанный e-mail (demouser@microsoft.com)-->
            <!--</div>
                    </label>
                    <div class="edm-connect__input-code js-input-code">
                        <label class="txt-input">
                            <div class="txt-input__input txt-input__input--code">
                                <input class="txt-input__field txt-input__field--code input" type="text" placeholder="Введите код">
                                <div class="txt-input__required txt-input__required--success">Код введен верно</div>
                                <div class="txt-input__required txt-input__required--error">Код введен неверно</div>
                            </div>
                        </label>
                    </div>
                </div>
                <div class="edm-connect__footer">
                    <button class="button button--th-second _light js-poison-code is-disable">Отправить</button>
                    <button class="button button--th-main js-connect-edm is-disable js-change-button-submit" style="display: none;">Подключить</button>
                    <button class="button button--th-main js-poison-code js-poison-code-again" style="display: none;">Повторить</button>
                    <div class="form-timer js-timer">
                        <svg class="form-timer__svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" fill="#fff">
                            <path stroke-dasharray="283"
                                  class="form-timer__circle js-timer-circle"
                                  d="
                                M 50, 50
                                m -45, 0
                                a 45,45 0 1,0 90,0
                                a 45,45 0 1,0 -90,0
                                "></path>
                        </svg>
                        <span class="js-timer-count form-timer__count">
                        </span>
                    </div>
                </div>
            </div>-->
            <!-- сообщение после проверки кода -->
            <!--<div class="edm-connect__message" style="display: none;">
                    <div class="edm-connect__message-title">
                        Заявка на подключение принята 11.05.2021 14:56
                    </div>
                    <div class="edm-connect__message-text">
                        Благодарим Вас за переход на безбумажную технологию обмена финансовыми документами через ЭДО.<br /> Все измененя вступят в силу с 1 числа следующего месяца. <br /> В дальнейшем Вы будете ежемесячно получать от нас документы в электронном виде.
                    </div>
                </div>
            </div>-->
        </div>
    </div>



</template>

<script type="text/javascript">
    export default {
        name: 'account-epd',
        props: {
            account: Object
        },

        data() {
            return {
                months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
                date: '',
                year: 2021,
                month: 0,
                handlers: new Map(),
                readyPdf: true,
                errorEPD: false
            };
        },

        mounted() {
            var picker = $("#date-picker-" + this.account.PersonAccountId);
            picker.datepicker({
                autoClose: true, 
                dateFormat: "MM yyyy",
                minDate: new Date(this.account.EpdStartDate), 
                maxDate: new Date(this.account.EpdEndDate), 
                view: 'months',
                minView: 'months',
                showButtonPanel: true,
                //position: 'right top'
            });
        },
        methods: {
            setperiod: function (Account) {
                var d = this.$refs.input.value;
                if (d !== '') {
                    this.date = d.trim();
                    const parts = this.date.split(" ");
                    this.month = this.months.indexOf(parts[0]) + 1;
                    this.year = parseInt(parts[1].trim());
                    this.getPdf2(Account);
                }
                else { return; }
            },
            //maxDate: function () {
            //    var d = new Date(this.account.EpdEndDate);
            //    var y = d.getFullYear();
            //    var m = d.getMonth() - 1;
            //    return new Date(y, m, 1);
            //},
            //minDate: function () {
            //    var d = new Date(this.account.EpdStartDate)
            //    var y = d.getFullYear();
            //    var m = d.getMonth();
            //    return new Date(y, m, 1);
            //},
            getPdf2: function (Account) {

                var self = this;
                console.log('getPdf-2 ', Account.BspId, Account.PersonAccountId);

                var year = this.year;
                var month = this.month;
                self.errorEPD = false;
                var accountNumber = Account.AccountNumber;

                if (month > 0 && year > 0) {

                    var _handler = self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month);
                    if (_handler != undefined) {
                        return;
                    }

                    self.readyPdf = !self.readyPdf;

                    self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, 0);
                    console.log('Формирование ЕПД | ', Account.BspId, Account.PersonAccountId, month, year);
                    axios.get('/fl/accounts/orderepd/' + Account.BspId + '/' + Account.PersonAccountId + '/' + year + '/' + month)
                        .then(function (response) {
                            console.log('Формирование ЕПД | response = ', response);
                            if (response.data !== 'error' && response.data !== '') {
                                const fileName = '' + accountNumber + '_' + year + '_' + month + '.pdf';
                                var handler = response.data;
                                console.log('Формирование ЕПД | handler = ', handler);
                                self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month,
                                    setInterval(() => {
                                        axios.get('/fl/accounts/getepd/' + handler + '/' + Account.BspId, {
                                            responseType: 'blob',
                                            timeout: 30000,
                                        })
                                            .then(function (response) {
                                                if (response.data == '') {
                                                    console.log('wait..');
                                                }
                                                else {
                                                    if (response.data.size > 0) {
                                                        if (self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month) > 0) {

                                                            clearInterval(self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month));
                                                            self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, null);
                                                            self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);

                                                        }
                                                        console.log('..ready');

                                                        let a = window.document.createElement('a');
                                                        a.href = window.URL.createObjectURL(response.data);
                                                        a.download = fileName;
                                                        document.body.append(a);
                                                        a.click();
                                                        console.log('..download');

                                                        self.readyPdf = !self.readyPdf;

                                                    }
                                                    else {
                                                        console.log('..data size = 0');
                                                    }
                                                }
                                            })
                                            .catch(function (error) {
                                                console.log('Ошибка получения данных: ' + error.message);
                                            });

                                    }, 5000)
                                );
                                setTimeout(() => {
                                    if (self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month) > 0) {

                                        clearInterval(self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month));
                                        self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, null);
                                        self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);

                                        console.log('..stop');
                                    }
                                }, 50000);

                            }
                            else {
                                console.log('Формирование ЕПД невозможно, повторите запрос позднее');
                                self.errorEPD = !self.errorEPD;
                                self.readyPdf = !self.readyPdf;
                            }
                        })
                        .catch(function (error) {
                            console.log('Ошибка формирования ЕПД: ' + error.message);
                            self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);
                        });
                }
                else {
                    console.log('error ', month, year, self.getPdfHandler);
                    self.handlers.delete(uaccount + '/' + year + '/' + month);
                }
            }

        }

    }
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/account-epd.vue